import React, {Component} from "react";
import {Button, Modal, Layout, Icon} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getNotPaidInvoices, getDoublePayment} from "../../../actions/thunks.js";
import {setFilterInvoicesByDay} from "../../../actions/actions.js";
import Piechart from "./PieChart";
import {formatAmount} from "utils";
import {getLocalStorageCoda} from "../../../api/PaymentAPI";
import isEmpty from "lodash/isEmpty";
import RecapByDay from "./RecapByDay";
import InvoiceDetail from "./InvoiceDetail";
import UnpaidInvoicesDetails from "./UnpaidInvoicesDetails";
import RecapByMonth from "./RecapByMonth";
import RecapByDate from "./RecapByDate";
import DoublePayment from "./DoublePayment";
import FeedMangoModal from "../FeedMangoWallet/FeedMangoModal";

const { Header, Footer, Sider, Content } = Layout;


class NotPaidInvoices extends Component {

  constructor(props) {
    super(props);

    this.state = {

      operation_type : null,
      visible: false,
      showSpinner : false,
      isMangoModalVisible: false,
      orderIdForMangoRefund: null,
      amountToRefund: 0,
    };
  }


  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getNotPaidInvoices(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])

    }
  }

  componentDidUpdate(prevProps, prevState)
  {
    if(prevProps.statisticsFilter !== this.props.statisticsFilter || prevProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.props.getNotPaidInvoices(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])

    }
  }


  showModal = (operation_type) => {
    this.setState({
      visible: true,
      operation_type : operation_type
    });
  };


  handleCancel = e => {
    this.setState({
      visible: false,
      operation_type : null
    });

    this.props.setFilterInvoicesByDay(null)
    this.setState({showSpinner: false});
  };

  changeState = (value) => {

    this.setState({showSpinner: value});
  }

  handleMangoModalVisibility = (value) => {
    this.setState({isMangoModalVisible: value});
  };

  openFeedMangoModal = (orderId, amountToRefund) => {
    this.setState({isMangoModalVisible: true, orderIdForMangoRefund: orderId, amountToRefund: amountToRefund});
    this.handleCancel()
  };

  render() {
    const {facturationInfos, notPaidInvoices } = this.props;
    let totalOrder = 0;
    let totalInvoice = 0;
    let amountInvoice = 0;

    if(facturationInfos && facturationInfos.items && facturationInfos.items['order']){
      totalOrder= (facturationInfos.items['order']['NOT_PAID'] ? parseInt(facturationInfos.items['order']['NOT_PAID'].count) : 0) + (facturationInfos.items['order']['PAID'] ? parseInt(facturationInfos.items['order']['PAID'].count) : 0)+ (facturationInfos.items['order']['OVER_PAID'] ? parseInt(facturationInfos.items['order']['OVER_PAID'].count) : 0) + (facturationInfos.items['order']['UNDER_PAID'] ? parseInt(facturationInfos.items['order']['UNDER_PAID'].count) : 0)
    }


    if(notPaidInvoices && notPaidInvoices.items && notPaidInvoices.items[0] && notPaidInvoices.items[0]['including_vat_amount']){
      totalInvoice= notPaidInvoices.items[0]['count_document'];
      amountInvoice= notPaidInvoices.items[0]['including_vat_amount'];
    }

    return (
      <div>
        <div className="fact-bloc">

          <div className="title">
            {_('mapCoda')}
          </div>

          <div>

            <Row gutter={16}>
              <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
                <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                  <div className="flex items-center justify-center img-reconciliation">
                    <img src={"/img/icons/Ogone-Big.svg"}/>
                  </div>

                  <div className="text-reconciliation pt-3">
                    {_('payment-ogone')}
                  </div>

                  <div className='pt-3 btn-reconciliation mt-20'>

                    <Button  type='default'  data-operation="OGONE" onClick={() => this.showModal("OGONE")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('OGONE')}

                    </Button>

                    {this.state.visible && this.state.operation_type === 'OGONE' && <Modal
                      // title={this.state.operation_type}
                      visible={true}
                      onCancel={this.handleCancel}
                      footer={null}
                      width={'97%'}
                      style={{ top: 18 }}
                    >

                      <div className="bg-blue-lightest h-16 modal-header-title">
                        {_(this.state.operation_type)}
                      </div>

                      <div className="flex flex-row mt-8">

                        <div className="relative">
                          <div className="min-h-full">

                            <RecapByDate operationType = {this.state.operation_type} changeState = {this.changeState}/>

                          </div>

                          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                            <Icon type="sync" spin style={{ fontSize: '50px'}} />

                          </div> : null
                          }
                        </div>
                        <div className="min-h-full w-full pl-8">
                          <InvoiceDetail operationType = {this.state.operation_type}/>
                        </div>
                      </div>
                    </Modal>}

                  </div>
                </div>
              </Col>


              <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
                <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                  <div className="flex items-center justify-center img-reconciliation">
                    <img src={"/img/icons/Payconiq-small.svg"}/>
                  </div>

                  <div className="text-reconciliation pt-3">
                    {_('payment-pay-coniq')}
                  </div>

                  <div className='pt-3 btn-reconciliation mt-20'>

                    <Button  type='default'  data-operation="PAY_CONIQ" onClick={() => this.showModal("PAY_CONIQ")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Pay Coniq')}

                    </Button>

                    {this.state.visible && this.state.operation_type === 'PAY_CONIQ' && <Modal
                      // title={this.state.operation_type}
                      visible={true}
                      onCancel={this.handleCancel}
                      footer={null}
                      width={'97%'}
                      style={{ top: 18 }}
                    >

                      <div className="bg-blue-lightest h-16 modal-header-title">
                        {_(this.state.operation_type)}
                      </div>

                      <div className="flex flex-row mt-8">

                        <div className="relative">
                          <div className="min-h-full">

                            <RecapByDate operationType = {this.state.operation_type} changeState = {this.changeState}/>

                          </div>

                          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                            <Icon type="sync" spin style={{ fontSize: '50px'}} />

                          </div> : null
                          }
                        </div>
                        <div className="min-h-full w-full pl-8">
                          <InvoiceDetail operationType = {this.state.operation_type}/>
                        </div>
                      </div>
                    </Modal>}

                  </div>
                </div>
              </Col>

              <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
                <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                  <div className="flex items-center justify-center img-reconciliation">
                    <img src={"/img/icons/mangopay-small.svg"}/>
                  </div>

                  <div className="text-reconciliation pt-3">
                    {_('payment-mango-pay')}
                  </div>

                  <div className='pt-3 btn-reconciliation mt-20'>

                    <Button  type='default'  data-operation="MANGO_PAY" onClick={() => this.showModal("MANGO_PAY")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Mango pay')}

                    </Button>

                    {this.state.visible && this.state.operation_type === 'MANGO_PAY' && <Modal
                      // title={this.state.operation_type}
                      visible={true}
                      onCancel={this.handleCancel}
                      footer={null}
                      width={'97%'}
                      style={{ top: 18 }}
                    >

                      <div className="bg-blue-lightest h-16 modal-header-title">
                        {_(this.state.operation_type)}
                      </div>

                      <div className="flex flex-row mt-8">

                        <div className="relative">
                          <div className="min-h-full">

                            <RecapByDate operationType = {this.state.operation_type} changeState = {this.changeState}/>

                          </div>

                          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                            <Icon type="sync" spin style={{ fontSize: '50px'}} />

                          </div> : null
                          }
                        </div>
                        <div className="min-h-full w-full pl-8">
                          <InvoiceDetail operationType = {this.state.operation_type}/>
                        </div>
                      </div>
                    </Modal>}

                  </div>
                </div>
              </Col>


              <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
                <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                  <div className="items-center justify-center img-reconciliation">
                    <img src={"/img/icons/BANK-TRANSFER.svg"}/>
                  </div>
                  <div className="text-reconciliation pt-4 ">
                    {_('payment-virement')}
                  </div>

                  <div className='pt-3 btn-reconciliation mt-20'>
                    <Button  type='default'  data-operation="BANK-TRANSFER" onClick={() => this.showModal("BANK_TRANSFER")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('BANK_TRANSFER')}

                    </Button>

                    {this.state.visible && this.state.operation_type === 'BANK_TRANSFER' && <Modal
                      visible={this.state.visible && this.state.operation_type === 'BANK_TRANSFER'}
                      onCancel={this.handleCancel}
                      footer={null}
                      width={'97%'}
                      style={{ top: 18 }}
                    >

                      <div className="bg-blue-lightest h-16 modal-header-title">
                        {_(this.state.operation_type)}
                      </div>

                      <div className="flex flex-row mt-8">

                        <div className="relative">

                          <div className="min-h-full">
                            <RecapByDate operationType = {this.state.operation_type} changeState = {this.changeState}/>
                          </div>

                          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                            <Icon type="sync" spin style={{ fontSize: '50px'}} />

                          </div> : null
                          }


                        </div>
                        <div className="min-h-full w-full pl-8">
                          <InvoiceDetail operationType = {this.state.operation_type}/>
                        </div>
                      </div>
                    </Modal>}
                  </div>

                </div>
              </Col>

              <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
                <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                  <div className="items-center justify-center img-reconciliation">
                    <img src={"/img/icons/wallet.svg"}/>
                  </div>
                  <div className="text-reconciliation pt-4">
                    {_('Consulter les commandes qui sont doublement payées')}
                  </div>

                  <div className='pt-3 btn-reconciliation mt-20'>
                    <Button  type='default'  data-operation="DOUBLE-PAYMENT" onClick={() => this.showModal("DOUBLE-PAYMENT")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Visualiser')}

                    </Button>

                    {this.state.visible && this.state.operation_type === 'DOUBLE-PAYMENT' && <Modal
                      visible={this.state.visible && this.state.operation_type === 'DOUBLE-PAYMENT'}
                      onCancel={this.handleCancel}
                      footer={null}
                      width={'97%'}
                      style={{ top: 18 }}
                    >
                      <div className="min-h-full">
                        <DoublePayment operationType = {"DOUBLE-PAYMENT"} openFeedMangoModal={this.openFeedMangoModal}/>
                      </div>

                    </Modal>}
                  </div>

                </div>
              </Col>

              <Col className="gutter-row" span={4}>
                <div className="gutter-box payment-bloc-background ">

                  <div className="sub-title-facturation">
                    {_('invoices-not-paid')}
                  </div>
                  <div className="line"/>

                  <div className="pl-24 md:pl-4 pt-4">
                    <Piechart total={totalOrder} count={totalInvoice} label = {'invoice'} pieColor = {'rgb(109, 127, 146)'} style={{opacity:0.1}} color = {'#FE3745'}/>

                    <div className="flex items-center justify-center flex-col mr-3 mb-4">
                      <div className="text-center div-total">
                        TOTAL
                      </div>
                      <div className="text-center div-amount self-start">
                        {formatAmount(amountInvoice)}
                      </div>

                      {/*<div className="div-not-paid-invoice self-start">*/}
                      {/*  {totalInvoice +' '+ _('facture-a-payer')}*/}
                      {/*</div>*/}

                      <div className='pt-3 btn-reconciliation' style={{marginTop: '0.1rem'}}>
                        <Button  type='default'  data-operation="UNPAID_INVOICES" onClick={() => this.showModal("UNPAID_INVOICES")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Visualiser')} </Button>


                        {this.state.visible && this.state.operation_type === 'UNPAID_INVOICES' && <Modal
                          visible={this.state.visible && this.state.operation_type === 'UNPAID_INVOICES'}
                          onCancel={this.handleCancel}
                          footer={null}
                          width={'97%'}
                          style={{ top: 26 }}
                        >

                          <div className="min-h-full">
                            <UnpaidInvoicesDetails operationType = {"UNPAID_INVOICES"}/>
                          </div>
                        </Modal>}

                      </div>

                    </div>

                  </div>
                </div>
              </Col>


            </Row>

          </div>
        </div>
        <FeedMangoModal isModalVisible={this.state.isMangoModalVisible}
                        handleModalVisibility={this.handleMangoModalVisibility}
                        orderId={this.state.orderIdForMangoRefund}
                        isCreditNote={0}
                        creditNoteId={null}
                        isRefund={1}
                        redirectionURL={window.location.href}
                        amountToRefund={this.state.amountToRefund}
        />
      </div>

    );
  }
}

const mapStateToProps = state => ({
  facturationInfos: state.facturationInfos,
  statisticsFilter: state.filters.statisticsFilter,
  eventStatsFilter: state.filters.eventStatsFilter,
  notPaidInvoices: state.notPaidInvoices,
  auth: state.auth,

});

const mapDispatchToProps = {
  getNotPaidInvoices,
  setFilterInvoicesByDay,
  getDoublePayment
};

export default connect(mapStateToProps, mapDispatchToProps)(NotPaidInvoices);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/NotPaidInvoices.js